import { render } from "./ConfirmDeleteComponent.vue?vue&type=template&id=28e89980"
import script from "./ConfirmDeleteComponent.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteComponent.vue?vue&type=script&lang=js"

import "./ConfirmDeleteComponent.vue?vue&type=style&index=0&id=28e89980&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__